<template>
  <div>
    <img class="banner" src="../assets/img/pc/banner.png" alt="" />

    <div class="header">
      <img
        class="logo"
        src="../assets/img/logo2.png"
        @click="$router.replace({ name: 'welcome' })"
      />
      <div>
        <dl class="nav-list">
          <dd :class="index == 1 ? 'on' : ''">
            <router-link :to="{ name: 'page1' }">@Rihao</router-link>
          </dd>
          <dd :class="index == 2 ? 'on' : ''">
            <router-link :to="{ name: 'page2' }">人才机遇</router-link>
            <div class="minBox">
              <a href="javascript:;" @click="hrefBy('page2', '#promotion')"
                >晋升通道</a
              >
              <a href="javascript:;" @click="hrefBy('page2', '#money')"
                >薪酬福利</a
              >
            </div>
          </dd>
          <dd :class="index == 3 ? 'on' : ''">
            <router-link :to="{ name: 'page3' }"> 校园招聘 </router-link>
            <div class="minBox">
              <a href="javascript:;" @click="hrefBy('page3', '#job')"
                >热招岗位</a
              >
              <a href="javascript:;" a @click="hrefBy('page3', '#flow')"
                >校招流程</a
              >
            </div>
          </dd>
          <dd :class="index == 4 ? 'on' : ''">
            <router-link :to="{ name: 'page4' }">联系我们</router-link>
            <div class="minBox">
              <a href="javascript:;" @click="hrefBy('page4', '#call')"
                >联系方式</a
              >
              <a href="http://www.rihaocpa.com/" target="_blank">官网</a>
            </div>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  props: {
    index: Number,
  },
  data() {
    return {
      isShow1: false,
    };
  },
  methods: {
    hrefBy(pageName, id) {
      console.log(this.$route.path);
      if(this.$route.path==('/'+pageName)){
 const returnEle = document.querySelector(id);
          console.log(returnEle);
          if (returnEle) {
            returnEle.scrollIntoView(true);
          }
      }else{
this.$router.replace({ name: pageName }).then(() => {
        setTimeout(() => {
          const returnEle = document.querySelector(id);
          console.log(returnEle);
          if (returnEle) {
            returnEle.scrollIntoView(true);
          }
        }, 100);
      });
      }
      
    },
  },
};
</script>

<style scoped lang="less">
.banner {
  width: 100%;
  padding-top: 72px;
}
.logo {
  margin-top: 10px;
  height: 60px;
  width: auto;
  flex-shrink: 0;
  cursor: pointer;
}
.header {
  font-size: 14px;
  width: 100%;
  border-bottom: 2px solid #cdcac6;
  background-color: #ffffff;
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  z-index: 999;
  justify-content: space-around;
}
.nav-list {
  margin: 0;
  dd {
    list-style: none;
    display: inline-block;
    position: relative;
    a {
      color: #000;
      padding: 20px 0;
      margin: 0 30px;
      font-weight: 900;
      display: block;
      text-decoration: none;
      font-size: 18px;
    }

    //下拉框
    .minBox {
      width: 100%;
      position: absolute;
      display: none;
      // bottom: -100px;
      left: 0;
      background: rgba(5, 85, 166, 0.78);
      padding: 10px 0;
      border-radius: 0 0 5px 5px;
      a {
        display: block;
        width: 100%;
        padding: 10px 0;
        text-align: center;
        color: #ffffff;
        margin: 4px 0;
      }
      a:hover {
        background-color: rgb(10, 150, 221);
      }
    }
  }
}
// 显示下拉框
.nav-list dd:hover .minBox {
  display: block;
}
// 选中状态
.nav-list dd.on > a {
  position: relative;
  color: rgb(5, 85, 166);
}
.nav-list dd.on > a::after {
  content: "";
  width: 100%;
  height: 5px;
  background-color: rgb(5, 85, 166);
  position: absolute;
  bottom: 0;
  left: 0;
}
</style>
